/** Joins the class names that are set, so a component can add a modifier only when it applies. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
